<template>
  <modal v-bind="$attrs"
         v-on="$listeners"
         :title="isEdit ? $t('phone.edit') : $t('phone.add')">
    <form @submit.prevent="onSubmit">
      <div class="w-full">
        <phone-input @input-data="onPhoneChange"
                     :name="$t('generic.phone')"
                     v-validate="modelValidations.phone"
                     v-model="model.phone">
        </phone-input>
      </div>
      <dl class="rounded overflow-hidden mt-6 mb-4">
        <div class="list-row bg-gray-50">
          <dt class="list-row-dt">
            {{$t(`generic.financial`)}}
          </dt>
          <dd class="list-row-dd">
            <base-switch v-model="model.financial"/>
          </dd>
        </div>
        <div class="list-row bg-white">
          <dt class="list-row-dt">
            {{$t(`generic.delivery`)}}
          </dt>
          <dd class="list-row-dd">
            <base-switch v-model="model.delivery"/>
          </dd>
        </div>
      </dl>
      <div class="w-full flex justify-center mt-6">
        <submit-button :loading="loading" native-type="submit"/>
      </div>
    </form>
  </modal>
</template>
<script>
  import PhoneInput from 'src/components/PhoneInput'

  export default {
    inheritAttrs: false,
    components: {
      PhoneInput
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      loading: Boolean,
    },
    data () {
      return {
        model: {
          phone: '',
          label: '',
          country_code: '',
          financial: null,
          primary: null,
          delivery: null,
        }
      }
    },
    computed: {
      isEdit () {
        return this.data && this.data.id
      },
      modelValidations () {
        return {
          country_code: {
            required: true,
          },
          phone: {
            required: true,
          },
        }
      }
    },
    methods: {
      onPhoneChange ({activeCountry}) {
        if (activeCountry && activeCountry.iso2) {
          this.model.country_code = activeCountry.iso2
        }
      },
      async onSubmit () {
        let res = await this.$validator.validateAll()
        if (!res) {
          return
        }
        this.model.label = this.model.phone
        this.$emit('submit', this.model)
      }
    },
    watch: {
      data: {
        immediate: true,
        handler (data) {
          if (!data) {
            return
          }
          this.model = {
            ...this.model,
            ...data
          }
        }
      }
    }
  }
</script>
<style>
</style>
